// extracted by mini-css-extract-plugin
export var buttonContainer = "GiftTray-module__buttonContainer___fRoMc";
export var container = "GiftTray-module__container___f1x0z";
export var headline = "GiftTray-module__headline___MpdzZ";
export var loginButton = "GiftTray-module__loginButton___YsIbk";
export var spacer = "GiftTray-module__spacer___ir520";
export var trayContent = "GiftTray-module__trayContent___Od2r5";